import userManager from "@rmp/core/services/auth/userManager";
import { signInConfig } from "@rmp/core/services/auth/signInConfig";
import User from "@rmp/core/services/auth/types/user";
import { plainToInstance } from "class-transformer";
import jwtDecode from "jwt-decode";

export default class SecurityService {
	constructor() {
	}
	
	async getUser(): Promise<User> {
		try {
			let user = await userManager.getUser() as any;
			
			// при первом входе берется пользователь из локального хранилища, почти всегда к этому моменту токен уже истек
			// это приводит к 401 коду, а если истек пароль, то еще и к отображению окна с необходимостью смены пароля
			// поэтому проверяем не только наличие пользователя, но и время жизни
			if(user == null || (!!user.expires_at && (user.expires_at * 1000 < Date.now()))) {
				await this.signinSilent();
				
				user = await userManager.getUser();
				
				if(!user)
					throw new Error();
			}
			
			let { PasswordExpiresAt } = jwtDecode<{ PasswordExpiresAt: string }>(user.access_token);
			
			const userInfo: User = {
				accessToken: user.access_token,
				profile: user.profile.profile,
				account: user.profile.account,
				isTemporaryPassword: user.profile.isTemporaryPassword,
				passwordExpiresAt: parseInt(PasswordExpiresAt) * 1000
			};
			
			return plainToInstance(User, userInfo);
		} catch (e) {
			console.error(e);
			throw e;
		}
	}
	
	async signinSilent() {
		return await userManager.signinSilent();
	}
	
	async signinRedirectCallback() {
		return await userManager.signinRedirectCallback();
	}
	
	async signinSilentCallback() {
		return await userManager.signinSilentCallback();
	}
	
	async reloadSession() {
		await userManager.removeUser();
		await userManager.clearStaleState();

		return await userManager.signinSilent();
	}
	
	onUserLoaded(callback: Parameters<typeof userManager.events.addUserLoaded>[0]) {
		return userManager.events.addUserLoaded(callback);
	}
	
	async signIn(params = {}, state = {})
	{
		try {
			await userManager.signinRedirect({
				extraQueryParams: {
					...signInConfig
				},
				state
			});
		} catch (e) {
			console.error(e);
			throw e;
		}
	}
	
	async signOut(postLogoutRedirectUrl?: string) {
		try {
			// TODO изучить в API дефолтное значение
			if(postLogoutRedirectUrl) {
				await userManager.signoutRedirect({
					post_logout_redirect_uri: postLogoutRedirectUrl
				});
			} else {
				await userManager.signoutRedirect();
			}
		} catch (e) {
			console.error(e);
		}
	}
	
	async getToken() {
		try {
			let user = await userManager.getUser();
			
			return user ? user.access_token : null;
		} catch (e) {
			console.error(e);
			throw e;
		}
	}
}
